import React from "react";

export default function BlogsMainSection({ children }) {
  return (
    <div className="col-lg-8 col-md-12">
      <div className="row blog-grid-row">{children}</div>
    </div>
  );
}
